export default __webpack_public_path__ + "static/media/44.60fc8d9e.jpg";